import React, { useContext, useState, useEffect } from 'react';
import { Context } from '../../../defaults';
import { Form, Select, Upload, message, Table, Card, Button } from 'antd';
import {
  getInstitutions,
  UploadDocument,
  FilterClassesByInstitutionId,
  getLanguagesType,
  saveEditedFileStudents,
  isLoginExist,
  getExcelFileTemplate,
  getWordFileTemplate,
} from '../../../actions';
import { InboxOutlined } from '@ant-design/icons';
import { Icon } from 'semantic-ui-react';
import { StudentsModal } from './StudentsModal';

const StudentsFile = () => {
  const { Dragger } = Upload;

  const { dictionary, language } = useContext(Context);
  const [institutionId, setInstitutionId] = useState();
  const [langId, setLangId] = useState();
  const [classId, setClassId] = useState();
  const [students, setStudents] = useState();
  const [institutions, setInstitutions] = useState();
  const [languagesType, setLanguagesType] = useState();
  const [classes, setClasses] = useState();
  const [modalProps, setModalProps] = useState({
    visible: false,
    actionType: null,
    currentStudent: null,
  });

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    },
  };

  useEffect(() => {
    getLanguagesType().then(({ data }) => setLanguagesType(data));
    getInstitutions().then(({ data }) => setInstitutions(data));
  }, []);

  const upload = ({ file, onSuccess }) => {
    const formData = new FormData();
    formData.append('institutionId', institutionId);
    formData.append('langId', langId);
    formData.append('classId', classId || '');
    formData.append('fileBytes', file);
    UploadDocument(formData).then((res) => {
      onSuccess('ok');
      setStudents(res);
    });
  };

  const saveEditedStudents = () => {
    saveEditedFileStudents(students).then((res) => {
      message.success(dictionary?.FileSuccessfullyUploaded[language]);
    });
  };

  const getExcelTemplate = () => {
    getExcelFileTemplate().then((res) => {
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Template.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  };

  const getWordTemplate = () => {
    getWordFileTemplate().then((res) => {
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Template.docx');
      document.body.appendChild(link);
      link.click();
    });
  };

  const closeModal = (editedStudents, index) => {
    setModalProps({ visible: false });
    if (editedStudents !== undefined && index !== undefined) {
      const clone = [...students];
      clone[index] = editedStudents;
      clone[index].users = { login: editedStudents.login, email: editedStudents.email };
      setStudents([...clone]);
    }
  };

  const columns = [
    {
      title: `${dictionary?.LastName[language]}`,
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: `${dictionary?.FirstName[language]}`,
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: `${dictionary?.MiddleName[language]}`,
      dataIndex: 'middleName',
      key: 'middleName',
    },
    {
      title: `${dictionary?.Phone[language]}`,
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: `${dictionary?.StudyYear[language]}`,
      dataIndex: 'studyYear',
      key: 'StudyYear',
    },
    {
      title: `${dictionary?.Country[language]}`,
      dataIndex: 'country',
      key: 'Country',
    },
    {
      title: `${dictionary?.Region[language]}`,
      dataIndex: 'region',
      key: 'Region',
    },
    {
      title: `${dictionary?.UserLogin[language]}`,
      dataIndex: 'login',
      key: 'login',
    },
    {
      title: `${dictionary?.Email[language]}`,
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: `${dictionary?.Action[language]}`,
      key: 'action',
      width: 100,
      fixed: 'right',
      render: (el, _, index) => (
        <Icon
          name="edit"
          onClick={() => {
            setModalProps({
              visible: !modalProps.visible,
              actionType: 'edit',
              index,
              currentStudent: el,
            });
          }}
        />
      ),
    },
  ];
  const selectedStudent = {
    students,
    institutions,
    languagesType,
    classes,
  };

  return (
    <div>
      <StudentsModal
        modalProps={modalProps}
        selectedValue={selectedStudent}
        closeModal={closeModal}
      />
      <Form {...formItemLayout}>
        <Form.Item
          label={`${dictionary?.Institution[language]}`}
          hasFeedback
          validateStatus={institutionId ? 'success' : 'error'}>
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSelect={(value) => {
              setInstitutionId(value);
              FilterClassesByInstitutionId(value).then(({ data }) => setClasses(data));
            }}>
            {institutions &&
              institutions.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {`${dictionary?.City[language][0].toLowerCase()} ${el.city},  ${el.name}`}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          label={`${dictionary?.Language[language]}`}
          hasFeedback
          validateStatus={langId ? 'success' : 'error'}>
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSelect={(value) => setLangId(value)}>
            {languagesType &&
              languagesType.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item label={`${dictionary?.Class[language]}`}>
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSelect={(value) => setClassId(value)}>
            {classes &&
              classes.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {`${el.year} ${el.letter}`}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item label={`${dictionary?.FileTemplate[language]}`}>
          <Button
            type="link"
            onClick={getExcelTemplate}>{`${dictionary?.ExcelFileTemplateDesc[language]}`}</Button>
          <Button type="link" onClick={getWordTemplate}>
            {`${dictionary?.WordFileTemplateDesc[language]}`})
          </Button>
        </Form.Item>
        <Form.Item
          label={`${dictionary?.StudentsFile[language]}`}
          hasFeedback
          validateStatus={students ? 'success' : 'error'}>
          <Dragger
            name="file"
            accept=".xls, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            customRequest={upload}
            disabled={!institutionId || !langId}
            onChange={(info) => {
              const { status } = info.file;
              if (status !== 'uploading') {
                console.log(info.file, info.fileList);
              }
              if (status === 'done') {
                message.success(dictionary?.FileSuccessfullyUploaded[language]);
              } else if (status === 'error') {
                message.error(dictionary?.FileUploadFailed[language]);
              }
            }}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">{dictionary?.UploadStudentsFile[language]}</p>
          </Dragger>
        </Form.Item>
        <Form.Item></Form.Item>
      </Form>
      <Card size="small" title={dictionary?.ConflictedAccounts[language]}>
        <Table
          style={{ marginTop: 24 }}
          scroll={{ x: 2000 }}
          columns={columns}
          dataSource={students}
          rowKey="id"
        />
        <Button
          type="primary"
          style={{ marginTop: 24 }}
          onClick={saveEditedStudents}
          disabled={students?.some((x) => !x.login)}>
          {dictionary?.Save[language]}
        </Button>
      </Card>
    </div>
  );
};

export default StudentsFile;
